import { NgModule } from "@angular/core";
import { routing } from './poll-pages.routing';
import { TYTCommonModule } from "@tytapp/common";
import { CommonModule } from "@angular/common";
import { ImageCropperModule } from "ngx-image-cropper";
import { PollsModule } from "@tytapp/polls";
import { FormsModule } from "@angular/forms";
import { UserModule } from "@tytapp/user";
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonUiModule } from "@tytapp/common-ui";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatNativeDateModule } from "@angular/material/core";
import { PollListComponent } from "./poll-list/poll-list.component";

import { PollPageComponent } from "./poll-page/poll-page.component";
import { BantaSdkModule } from "@banta/sdk";
import { ChatModule } from "@tytapp/chat/chat.module";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { PollPostEditorComponent } from './poll-post-editor/poll-post-editor.component';
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from '@angular/material/select';
import { TopicsModule } from '@tytapp/topics';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDividerModule } from '@angular/material/divider';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBarModule } from '@angular/material/snack-bar';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,

        ImageCropperModule,
        TextFieldModule,
        DragDropModule,
        MatInputModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
        MatTabsModule,
        MatDividerModule,
        MatTooltipModule,
        MatSnackBarModule,

        TYTCommonModule,
        CommonUiModule,
        ChatModule,
        UserModule,
        TopicsModule,
        PollsModule,
        routing,
    ],
    declarations: [
        PollListComponent,
        PollPageComponent,
        PollPostEditorComponent
    ]
})
export class PollPagesModule {

}
